












import i18n from '@/i18next';

export default {
  props: {
    type: {
      type: Object,
      required: true,
    },
    onEnter: {
      type: Function,
    },
    translate: {
      default() {
        return {
          text(key : string) {
            return i18n.t(key);
          },
        };
      },
    },
  },
};

